import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { EditableImage } from "../../../header/editable/editable-image"
import { getRatio } from "../../components/column-ratio"
import { InheritedThemeProvider } from "@convertkit/editor"

const DEFAULT_IMAGE_URL =
  "https://cdn.convertkit.com/assets/article-layout-placeholder.jpeg"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-sponsorctaleft td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .ck-sponsorctaleft img {
      margin-top: 18px !important;
    }
  }
`

export function SponsorCTALeftSmallImage({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    imageBorderRadius: properties.imageBorderRadius,
    paddingTop: properties.verticalPadding,
    paddingRight: properties.horizontalPadding,
    paddingBottom: properties.verticalPadding,
    paddingLeft: properties.horizontalPadding,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid",
    overflow: "hidden"
  }

  return (
    <div
      className="ck-sponsorctaleft ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <InheritedThemeProvider
        theme={{
          paragraph: {
            color: properties.sponsorLabelColor,
            fontWeight: properties.sponsorLabelFontWeight,
            fontFamily: properties.sponsorLabelFontFamily,
            fontSize: 11
          },
          h3: {
            color: properties.headingColor,
            fontWeight: properties.headingFontWeight,
            fontFamily: properties.headingFontFamily,
            fontSize: 24
          }
        }}
      >
        <LiteSlateEditor block_id={children[0].block_id} />
      </InheritedThemeProvider>

      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width={getRatio(properties.columnRatio, "left")}
              style={{ verticalAlign: "top", paddingRight: "16px" }}
            >
              <InheritedThemeProvider
                theme={{
                  paragraph: {
                    color: properties.textColor,
                    fontWeight: properties.textFontWeight,
                    fontFamily: properties.textFontFamily
                  }
                }}
              >
                <LiteSlateEditor block_id={children[1].block_id} />
              </InheritedThemeProvider>
            </td>
            <td
              width={getRatio(properties.columnRatio, "right")}
              style={{ paddingRight: "8px" }}
            >
              <EditableImage
                name="image"
                src={properties.image || DEFAULT_IMAGE_URL}
                alt={properties.alt}
                width="100%"
                height="auto"
                style={{
                  maxWidth: "100%",
                  display: "block",
                  marginTop: "12px",
                  borderRadius: properties.imageBorderRadius
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
